import { useEffect, useState } from 'react';
import getColumnClass from '../../utils/getColumnClass';
import CardSkeleton from '../Common/CardSkeleton';
import GridControls from '../Common/GridControls';
import ProductCard from '../Shop/ProductCard';

function GuaranteedProd({ guaranteedProducts, error, isLoading }) {
  const [gridSize, setGridSize] = useState(() => {
    const storeGridZize = localStorage.getItem('GuaranteedProdGridSize');
    return storeGridZize ? parseInt(storeGridZize, 10) : 4;
  });
  useEffect(() => {
    localStorage.setItem('GuaranteedProdGridSize', gridSize.toString());
  }, [gridSize]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="container-fluid px-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-12 text-center">
          <div className="categories_title">
            <h2 className="fw-bold">Guaranteed Lowest Prices</h2>
            <hr className="featured_underline mb-3" />
          </div>
          <div className="price_grnted_product_text">
            <p>
              Give your home a new look with our selected accessories — stylish,
              strong, and low in price.
            </p>
          </div>
        </div>
      </div>
      <GridControls
        gridSize={gridSize}
        setGridSize={setGridSize}
        windowWidth={windowWidth}
      />
      <div className="row">
        {error && <em className="form_error">{error}</em>}
        {isLoading && <CardSkeleton cards={8} />}
        {guaranteedProducts.map((product) => (
          <div
            key={product.product_id}
            className={`${getColumnClass(gridSize, windowWidth)} p-2`}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default GuaranteedProd;
